module.exports = __webpack_public_path__ + "static/img/downloadappbg-2.9468585.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/download/downloadappbg-2.jpg
// module id = oUnA
// module chunks = 7